import React from "react";
import ResponseContainer from "./ResponseContainer";
import ResponseContainerEmptyState from "../../../EmptyStates/ResponseContainerEmptyState";

export default function Response({ responseOptions, loadingMessage, isScrollComplete, editedResponseObj, editedSubjectObj, msgSourceName }) {

    if(loadingMessage) return <ResponseContainerEmptyState />;
    return <ResponseContainer
        responseOptions={responseOptions}
        isScrollComplete={isScrollComplete}
        editedResponseObj={editedResponseObj}
        editedSubjectObj={editedSubjectObj}
        msgSourceName={msgSourceName}
    />;
}